import React            from 'react';
import {observer} from 'mobx-react';
import {withRouter}     from 'react-router-dom';
import {withState} from 'shared/core';
import LandingContainer from './LandingContainer';
import PerformanceSubnav from 'containers/performance/components/PerformanceSubnav';
import CycleState from '../../../state/cycles/CycleState';

@observer class PerformanceIndex extends React.Component {
  render() {
    const {uiState} = this.props;

    return (
      <div>
        <PerformanceSubnav isLeader={uiState.isLeader}/>
        <div className="Container">
          <LandingContainer
            cycles={uiState.allCycles}
            uiState={uiState.uiState}
            onCheckInCreated={uiState.onCheckInCreated}
            onCycleDeleted={uiState.onCycleDeleted}
            onCycleArchived={uiState.onCycleArchived}
            onCycleClicked={uiState.onCycleClicked} />
        </div>
      </div>
    );
  }
}

export default withRouter(withState(PerformanceIndex, CycleState));
